import Button from "@/components/Button";
import type { MaterialNames } from "@/components/material_symbol_names";
import PlaceholderCard from "@/components/PlaceholderCard";

import type { CareerPlanSection } from "./careerPlanDocument";

export const CAREER_PLAN_SECTION_ICONS = {
  careerTarget: "track_changes",
  strengths: "trophy",
  focusAreas: "center_focus_weak",
  actionPlan: "checklist",
  additionalNotes: "sticky_note_2"
} as const satisfies Record<Exclude<CareerPlanSection, "details">, MaterialNames>;

export const CAREER_PLAN_SECTION_ADD_TEST_IDS = {
  careerTarget: "add-careerTarget",
  strengths: "add-strengths",
  focusAreas: "add-focusAreas",
  actionPlan: "add-action-row",
  additionalNotes: "add-additionalNotes"
} as const satisfies Record<Exclude<CareerPlanSection, "details">, string>;

type CareerPlanEmptySectionProps = {
  section: Exclude<CareerPlanSection, "details">;
  title: string;
  addLabel: string;
  canManage: boolean;
  disabled?: boolean;
  onAdd: () => void;
};

export default function CareerPlanEmptySection({
  section,
  title,
  addLabel,
  canManage,
  disabled = false,
  onAdd
}: CareerPlanEmptySectionProps) {
  return (
    <PlaceholderCard
      iconName={CAREER_PLAN_SECTION_ICONS[section]}
      title={title}
      testId={`career-plan-${section}-empty`}
    >
      {canManage ? (
        <Button
          type="button"
          variant="filledTonal"
          icon="add"
          onClick={onAdd}
          disabled={disabled}
          testId={CAREER_PLAN_SECTION_ADD_TEST_IDS[section]}
        >
          {addLabel}
        </Button>
      ) : null}
    </PlaceholderCard>
  );
}
